import { Text as NbText } from 'native-base';

import { addWithConfig } from '../../utils';

import type { TextProps } from './types';

export const Text = (props: TextProps) => <NbText variant="copyOne" {...props} />;

export default addWithConfig(Text);
